import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { applyTheme, getTheme } from './theme'

// Apply the persisted/OS theme before the first render, so the anonymous pages
// (/login, /newcustomer — rendered outside the header that hosts the toggle)
// honor dark mode too. getTheme never throws (blocked storage → OS preference).
applyTheme(getTheme())

const PRELOAD_RELOAD_KEY = 'vite:preloadError:lastReload'

/** A lazy chunk failing to load almost always means index.html is stale (a
 *  deploy replaced the hashed chunks), so reload once for the fresh shell.
 *  The timestamp guard prevents a reload loop if the chunk is genuinely gone;
 *  with storage blocked there's nowhere to keep it, so we don't reload at all
 *  and the page ErrorBoundary's Reload button is the way out. */
export function handlePreloadError(reload: () => void = () => window.location.reload()): void {
  try {
    const last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY) || '0')
    if (Date.now() - last <= 10_000) return
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()))
  } catch {
    return
  }
  reload()
}

window.addEventListener('vite:preloadError', () => handlePreloadError())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
